/**
 * Menu-hub tutorials replayable from Lore → Tutorials.
 * Excludes campaign in-battle tutorial missions (SimpleTutorialDialog / mission JSON).
 */
export const MENU_TUTORIAL_CATALOG = [
  { messageKey: 'command_hub', route: '/welcome', labelKey: 'lore.tutorials.entries.commandHub' },
  { messageKey: 'strategy', route: '/strategy', labelKey: 'lore.tutorials.entries.strategy' },
  { messageKey: 'command_center', route: '/command-center', labelKey: 'lore.tutorials.entries.commandCenter' },
  { messageKey: 'honor_hall', route: '/honor-hall', labelKey: 'lore.tutorials.entries.honorHall' },
  { messageKey: 'lore', route: '/lore', labelKey: 'lore.tutorials.entries.lore' },
  { messageKey: 'profile', route: '/profile', labelKey: 'lore.tutorials.entries.profile' },
  { messageKey: 'bank', route: '/bank', labelKey: 'lore.tutorials.entries.bank' },
  { messageKey: 'battle_overview_attack', route: '/battleoverview', labelKey: 'lore.tutorials.entries.battleOverview' },
  { messageKey: 'black_ops', route: '/blackops', labelKey: 'lore.tutorials.entries.blackOps' },
  { messageKey: 'dispatch_asset', route: '/dispatch-asset', labelKey: 'lore.tutorials.entries.dispatchAsset' },
  {
    messageKey: 'war_effort_purpose_selection',
    route: '/wareffort',
    labelKey: 'lore.tutorials.entries.warEffortPurpose',
  },
  { messageKey: 'explore_unknown', route: '/explore-unknown', labelKey: 'lore.tutorials.entries.exploreUnknown' },
];
